import type { NotificationMap } from '@bb/domain/dist/types/AppointmentConfig';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const saveBuyerNotification = async ({
  dashboardId,
  ...data
}: {
  dashboardId: string;
  buyerNotifications?: NotificationMap;
  buyerEmailDelivery?: boolean;
}) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/buyerNotifications`,
    method: 'post',
    data,
  };

  await axios.request(config);
};

export default saveBuyerNotification;
